module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [(_vm.hasHero) ? _c('hero', {
    attrs: {
      "page": _vm.page
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "postContent",
    style: ({
      background: 'transparent',
      width: '100%'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.page.policy_id) ? _c('div', {
    staticClass: "fullWidth"
  }, [(!_vm.hasHero) ? _c('h1', {
    staticClass: "pageTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.page.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.page.policy_id) ? _c('div', {
    staticClass: "fullWidth"
  }, [(_vm.policy) ? _c('div', {
    attrs: {
      "id": "policy-embed"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.policy)
    }
  }) : _c('div', [_c('p', [_vm._v("\n            Please wait while the policy is loaded. If it does not load, please "), _c('a', {
    attrs: {
      "href": ("https://app.termageddon.com/api/policy/" + (_vm.page.policy_id) + "?h-align=left&no-title=true&table-style=accordion"),
      "target": "_blank",
      "rel": "nofollow noopener"
    }
  }, [_vm._v("click here")]), _vm._v(".\n          ")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57f6c727"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page.vue
// module id = 782
// module chunks = 1